/* eslint-disable @typescript-eslint/no-explicit-any */
export default function (arrays: any[][]): any[] {
  let jointArray: any[] = [];

  arrays.forEach((array) => {
    jointArray = [...jointArray, ...array];
  });
  return [...new Set([...jointArray])];
}
